export default [{
  id: 'agency_name',
  name: 'Campaign Name & Dates',
}, {
  id: 'address',
  name: 'Campaign Targets',
}, {
  id: 'zipcode',
  name: 'Campaign\'s Associated Agencies',
}];
